import { Body } from './Body';
import { Root } from './Card';
import { Footer } from './Footer';
import { Header } from './Header';

export const Card = {
  Root: Root,
  Header: Header,
  Body: Body,
  Footer: Footer,
};
